// extracted by mini-css-extract-plugin
module.exports = {"menuBg":"#2b2218","menuText":"rgba(255,248,237,.72)","menuActiveText":"#ffd666"};